import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import BrushBarChart from './BrushBarChart'
import ZoomBarChart from './ZoomBarChart'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import DateRangeIcon from '@material-ui/icons/WatchLater'
import Tooltip from '../components/Tooltip'

const styles = theme => ({
  wrapperInner: {
    height: '100%'
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  flexGrow: {
    flex: '1 1 auto'
  }
})

class ZoomBrushBarChart extends PureComponent {
  constructor (props) {
    super()
    const { domain } = props

    this.state = {
      zoomDomain: domain,
      selectedDomain: domain,
      expanded: true,
      brushExpanded: false
    }
  }

  componentWillReceiveProps = nextProps => {
    if (
      new Date(nextProps.datetime).getYear() !==
      new Date(this.props.datetime).getYear()
    ) {
      this.setState({
        zoomDomain: nextProps.domain,
        selectedDomain: nextProps.domain
      })
    }
  }

  handleExpandClicked = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }

  handleBrushExpandClicked = () => {
    const { brushExpanded } = this.state
    this.setState({ brushExpanded: !brushExpanded })
  }

  handleBrush = domain => {
    this.setState({ zoomDomain: domain })
  }

  handleZoom = domain => {
    // this.setState({ selectedDomain: domain })
  }

  render () {
    const { data, title, classes, chartStyles, datetime } = this.props
    const { expanded, brushExpanded } = this.state

    return (
      <Collapse
        component='div'
        in={arrayIsNotEmpty(data)}
        unmountOnExit
        classes={{
          wrapperInner: classes.wrapperInner
        }}
      >
        <Toolbar>
          <Typography>{title}</Typography>
          <div className={classes.flexGrow} />
          <IconButton
            className={classes.expand}
            onClick={this.handleBrushExpandClicked}
            aria-expanded={brushExpanded}
            aria-label='Show more'
            color={brushExpanded ? 'inherit' : 'default'}
          >
            {expanded && (
              <Tooltip
                id='zoomChartTooltip'
                title='date range'
                placement='left'
              >
                <DateRangeIcon />
              </Tooltip>
            )}
          </IconButton>
          <Tooltip
            id='expandTooltip'
            title={expanded ? 'hide' : 'show'}
            placement={expanded ? 'bottom' : 'left'}
          >
            <IconButton
              className={classes.expand}
              onClick={this.handleExpandClicked}
              aria-expanded={expanded}
              aria-label='Show more'
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Tooltip>
        </Toolbar>
        <Collapse
          in={expanded}
          classes={{
            wrapperInner: classes.wrapperInner
          }}
        >
          <Collapse
            in={brushExpanded}
            classes={{
              wrapperInner: classes.wrapperInner
            }}
          >
            <BrushBarChart
              data={data}
              x={datum => new Date(datum.timestamp)}
              y={datum => datum.value}
              selectedDomain={this.state.selectedDomain}
              handleBrush={this.handleBrush}
              chartStyles={chartStyles}
            />
          </Collapse>
          <ZoomBarChart
            data={data}
            x={datum => new Date(datum.timestamp)}
            y={datum => datum.value}
            zoomDomain={this.state.zoomDomain}
            handleZoom={this.handleZoom}
            chartStyles={chartStyles}
            datetime={datetime}
          />
        </Collapse>
      </Collapse>
    )
  }
}

export default withStyles(styles)(ZoomBrushBarChart)



// WEBPACK FOOTER //
// ./src/charts/BrushZoomChart.js